import React from 'react';
import { motion } from 'framer-motion';
const SHOPIFY_CHECKOUT_URL = 'https://simpleymejor.com/checkouts/cn/hWNASAa8z4eXUTC40hc2WecE/en-ar?_r=AQABwDzL_wa45cDr4ir7en_kuI09JFY1VoBUrucWkp9qJzI&preview_theme_id=149103968433';
interface CTAButtonProps {
  onClick?: () => void;
  href?: string;
  children?: React.ReactNode;
  className?: string;
}
export function CTAButton({
  onClick,
  href = SHOPIFY_CHECKOUT_URL,
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    // Track InitiateCheckout on every CTA click
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
    if (onClick) {
      onClick();
    } else {
      window.open(href, '_blank');
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`bg-gradient-cta px-8 h-[52px] md:h-auto md:px-12 md:py-6 rounded-xl font-body font-semibold md:font-extrabold text-primary-foreground shadow-gold hover:shadow-rosa transition-shadow duration-300 w-full md:w-auto text-center text-base md:text-lg ${className}`} data-id="element-80">
      {children || 'QUIERO EMPEZAR HOY'}
    </motion.button>;
}